<template>
    <VJoyTooltip variant="primary" :text="$t('profile.card.external.client.recommendation.tooltip')">
        <div class="recommendations">
            <VJoyIcon name="thumbup" color="secondary" size="xsmall" class="joy-mr-1" />
            {{ recommendationsCount }}
        </div>
    </VJoyTooltip>
</template>

<script setup lang="ts">
    import {VJoyIcon, VJoyTooltip} from '@maltjoy/core-vue';

    defineProps<{
        recommendationsCount: number;
    }>();
</script>

<style scoped lang="scss">
    .recommendations {
        display: flex;
        align-items: center;
    }
</style>
